import BaseOptionsComponentController from '../base_options_component_controller';
import {GEO_LOCATION_COMPONENT_CONSTS} from './geo_location_component_consts';
import {PRIORITY_LEVEL} from '../../../../services/overlay_manager/overlay_manager_levels';



class GeoLocationController extends BaseOptionsComponentController {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GeoLocationController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-geo-location';


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-geo-location-component';



    init(params) {
        super.init();
        this._setHtml(GEO_LOCATION_COMPONENT_CONSTS.PC);
    }


    _setHtml(html) {

        let screen = this.bake(html);
        this.setHTML(screen);
    }
    _getTitleKey() {
        return 'geo_location_title';// TODO change to const after TypeScript migration
    }

    close() {
        super.destroy();
    }
    /**
     * close button display false
     */
    _isCloseButtonEnabled() {
        return false;
    }

    /**
     * Get priority to option message
     * @returns {number}
     */
    getOverlayPriority() {
        return PRIORITY_LEVEL.GEO_FREEZE_WINDOW;
    }

}
export default GeoLocationController;